import { CircularProgress } from '@material-ui/core';
import { StatusOptions } from '@models/Onboarding.model';
import { useMemo } from 'react';

import {
  RequestStatusWrapper,
  RequestStatusBadge,
  RequestStatusTag,
  CircularFileImportProgressWrapper,
} from './RequestStatus.styles';

type StatusProps = {
  status?: StatusOptions;
  progress?: number;
};

const RequestStatus = ({ status = 'importing', progress }: StatusProps) => {
  const tag = useMemo((): string => {
    switch (status) {
      case 'closed':
        return 'Closed';
      case 'open':
        return 'Imported';
      case 'aborted':
        return 'Error';
      case 'deleted':
        return 'Deleted';
      default:
        return 'Identifying Assets';
    }
  }, [status]);

  return (
    <RequestStatusWrapper>
      {status === 'importing' ? (
        <CircularFileImportProgressWrapper>
          <CircularProgress
            variant="determinate"
            value={100}
            thickness={8}
            size={14}
            className="overllProgress"
          />
          <CircularProgress
            variant="determinate"
            value={progress}
            thickness={8}
            size={14}
            className="completedProgress"
          />
        </CircularFileImportProgressWrapper>
      ) : (
        <RequestStatusBadge $status={status} />
      )}

      <RequestStatusTag $status={status}>{tag}</RequestStatusTag>
    </RequestStatusWrapper>
  );
};

export { RequestStatus };
